// C:\Users\abdul\Downloads\Onebox\onebox\src\components\Stats.jsx
import React from 'react';
import { FaUtensils, FaUsers, FaStar, FaTrophy, FaHeart, FaThumbsUp } from 'react-icons/fa';
import { GiChefToque } from 'react-icons/gi';
import { MdFastfood } from 'react-icons/md';
import './Stats.css';

const Stats = ({ tenant, data }) => {
  console.log('Stats received:', { tenant, data });
  
  // Default stats data
  const defaultStats = [
    {
      icon: 'chef',
      label: 'Professional Chefs',
      value: '420'
    },
    {
      icon: 'food',
      label: 'Items Of Food',
      value: '320'
    },
    {
      icon: 'experience',
      label: 'Years Of Experienced',
      value: '30+'
    },
    {
      icon: 'customers',
      label: 'Happy Customers',
      value: '220'
    }
  ];

  // Get stats from data or use defaults
  const stats = (data && Array.isArray(data.stats)) ? data.stats : defaultStats;
  const primaryColor = (tenant && tenant.primary_color) ? tenant.primary_color : '#FF9F0D';

  // Icon mapper - converts string names to React Icon components
  const getIcon = (iconName) => {
    const iconMap = {
      'chef': <GiChefToque />,
      'food': <MdFastfood />,
      'experience': <FaUtensils />,
      'customers': <FaUsers />,
      'star': <FaStar />,
      'trophy': <FaTrophy />,
      'heart': <FaHeart />,
      'thumbsup': <FaThumbsUp />,
    };
    return iconMap[iconName] || <FaUtensils />;
  };

  return (
    <section className="stats-section">
      <div className="stats-container">
        {stats.map((stat, index) => {
          // Ensure stat is an object
          if (!stat || typeof stat !== 'object') {
            return null;
          }

          return (
            <div key={index} className="stat-item">
              <div className="stat-icon" style={{ color: primaryColor }}>
                {getIcon(stat.icon)}
              </div>
              <div className="stat-content">
                <h3 className="stat-value">{stat.value || '0'}</h3>
                <p className="stat-label">{stat.label || ''}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Stats;
